import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCustomer } from '../customHooks/useCustomer';
import './OAuthCallback.css';

interface Props {
  language?: string;
  country?: string;
}

const OAuthCallback: React.FC<Props> = ({ language, country }) => {

  const [searchParams,] = useSearchParams();
  const navigate = useNavigate();
  const { saveCustomer } = useCustomer();

  useEffect(() => {
    const processOAuthCallback = () => {
      try {
        // Parse query parameters from the URL
        const token = searchParams.get('token');
        const customerID = searchParams.get('customerID');
        const uuid = searchParams.get('uuid');
        const email = searchParams.get('email') || '';
        const redirectPath = searchParams.get('redirectPath');
        const cameFromPath = searchParams.get('cameFromPath');
        const showOauthAdditionalInfoModal = searchParams.get('showOauthAdditionalInfoModal');


        // if we need more info, redirect to where we came from and open the modal
        if (cameFromPath && showOauthAdditionalInfoModal === 'true') {
          const url = new URL(window.location.origin + '/' + cameFromPath.replace(/^\/+/, ''));
          url.searchParams.append('provider', searchParams.get('provider') || '');
          url.searchParams.append('email', searchParams.get('email') || '');
          url.searchParams.append('firstName', searchParams.get('firstName') || '');
          url.searchParams.append('lastName', searchParams.get('lastName') || '');
          url.searchParams.append('externalAccessToken', searchParams.get('externalAccessToken') || '');
          url.searchParams.append('accessToken', searchParams.get('accessToken') || ''); // backward compatibility
          url.searchParams.append('refreshToken', searchParams.get('refreshToken') || '');
          url.searchParams.append('showOauthAdditionalInfoModal', searchParams.get('showOauthAdditionalInfoModal') || '');
          
          // Pass language and country from URL params or props
          const urlLanguage = searchParams.get('language') || language;
          const urlCountry = searchParams.get('country') || country;
          if (urlLanguage) url.searchParams.append('language', urlLanguage);
          if (urlCountry) url.searchParams.append('country', urlCountry);
          
          window.location.href = url.toString();
          return;
        }

        if (!token || !customerID || !uuid) {
          throw new Error('Missing required authentication parameters');
        }

        if (redirectPath) {
          // Save customer (states & eventsTracking)
          saveCustomer({
            customerID,
            uuid,
            token,
            email,
            fullName: searchParams.get('customerFullName') || '',
            optForSendables: searchParams.get('optForSendables'),
            loginSource: 'oauth',
            provider: searchParams.get('provider') || 'local',
            gender: searchParams.get('gender') ? parseInt(searchParams.get('gender')!) : undefined,
            lastPaidCategoryMention: searchParams.get('lastPaidCategoryMention') || ''
          });

          navigate('/' + redirectPath.replace(/^\/+/, ''), { replace: true });
        }

      } catch (err) {
        window.clientLogger.error("Error in OAuthCallback", { err })
      }
    };

    processOAuthCallback();
  }, [searchParams, navigate, saveCustomer]);


  // This shouldn't be visible as we redirect immediately on success
  return null;
};

export default OAuthCallback; 